export default function TableContainer(theme) {
    return {
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    borderRadius: 4,
                    boxShadow: 'none',
                    border: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.divider : theme.palette.grey.A800}`
                }
            }
        }
    };
}
